import { useUpdateChartConfigMutation } from '@api/chart';
import { updateNewConfig } from '@pages/EditChart/slice';
import { RootState } from '@store/store';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useChartConfig = () => {
  const [chartReset, setChartReset] = useState<string>('');

  const [updateChartConfig, { isLoading }] = useUpdateChartConfigMutation();
  const currentChartData = useSelector(
    (state: RootState) => state?.currentChartData
  );
  const dispatch = useDispatch();

  const getChartConfigs = async (configPayload: {
    id: string;
    payload: {
      field: string;
      value: any;
    };
  }) => {
    try {
      const response = await updateChartConfig(configPayload).unwrap();

      if (configPayload?.payload?.value === 'PIE')
        await getChartConfigs({
          id: configPayload.id,
          payload: { field: 'segment_field', value: null }
        });

      if (response) dispatch(updateNewConfig(response));

      return response;
    } catch (err: any) {
      console.log(err);
      if (err.status === 400 && err.data[0].includes('Chart not possible'))
        setChartReset(err.data[0].split(':')[1]);
    }
  };

  return {
    getChartConfigs,
    data: currentChartData.newConfig,
    isLoading,
    chartReset,
    setChartReset
  };
};

export default useChartConfig;
